'use strict';

var _ = require('lodash');
var FaresOptimizerChartsController = function FaresOptimizerChartsController($scope, hostViewChartDataService, competitiveViewChartDataService, FaresOptimizerConstants) {
  $scope.isShowCurrentFares = false;
  $scope.displayCurrentFares = false;
  $scope.showCurrentFareLink = 'Show current fares';
  $scope.isRecommendationShown = false;
  $scope.displayRecommendedFares = false;
  $scope.showRecommendedFareLink = 'Show recommendation';
  $scope.showCompareButton = $scope.screenState.recommendationDetailsMode === FaresOptimizerConstants.HOST_VIEW;
  $scope.screenState.selectedHostLadder = undefined;
  $scope.isWebFareChart = false;
  $scope.webFareChartData = undefined;
  $scope.$watch('chartData.data', function (data) {
    if (data) {
      $scope.chartData.status = data.status;
      if (isHostView(data)) {
        transformHostViewData(data);
      }
      if (isCompetitiveView(data)) {
        transformCompetitiveViewData(data);
      }
    }
  }, true);
  function transformHostViewData(data) {
    var transformedHostViewData = hostViewChartDataService.getChartDataForHostView(data, $scope.settings);
    $scope.fareLadderDefault = transformedHostViewData.fareLadderData;
    $scope.currentFareLadderData = transformedHostViewData.currentFareLadderData;
    $scope.recommendedFareLadderData = transformedHostViewData.recommendedFareLadderData;
    $scope.settings = transformedHostViewData.settings;
  }
  function transformCompetitiveViewData(data) {
    if (isCompetitiveView(data)) {
      $scope.settings = _.isNil($scope.settings) ? {} : $scope.settings;
      var transformedCompViewData = competitiveViewChartDataService.getChartDataForCompetitiveView($scope.chartData, $scope.settings);
      if (transformedCompViewData !== undefined) {
        $scope.fareLadderDefault = transformedCompViewData.fareLadderData;
        $scope.showAdjustDatesAndFares = transformedCompViewData.showAdjustDatesAndFares;
        $scope.isRecommendedFareChart = transformedCompViewData.isRecommendedFareChart;
        $scope.settings = transformedCompViewData.settings;
        $scope.isWebFareChart = transformedCompViewData.isWebFareChart;
        $scope.webFareChartData = transformedCompViewData.webFareChartData;
      }
    }
  }
  function isCompetitiveView(data) {
    return data && $scope.screenState.recommendationDetailsMode === FaresOptimizerConstants.COMPETITIVE_VIEW && (data.showAdjustFares === undefined || data.showAdjustFares === false);
  }
  function isHostView(data) {
    return data && $scope.screenState.recommendationDetailsMode === FaresOptimizerConstants.HOST_VIEW;
  }
  $scope.showCurrentFares = function () {
    $scope.displayCurrentFares = !$scope.displayCurrentFares;
    $scope.showCurrentFareLink = $scope.displayCurrentFares ? 'Hide current fares' : 'Show current fares';
  };
  $scope.showRecommendedFares = function () {
    $scope.displayRecommendedFares = !$scope.displayRecommendedFares;
    $scope.showRecommendedFareLink = $scope.displayRecommendedFares ? 'Hide recommendation' : 'Show recommendation';
  };
  $scope.showIfChartDates = function () {
    return $scope.screenState.recommendChartMode === 'DATECHART';
  };
  $scope.showIfChartFares = function () {
    return $scope.screenState.recommendChartMode === 'FARECHART';
  };
  $scope.doCompare = function () {
    $scope.screenState.recommendationDetailsMode = FaresOptimizerConstants.COMPETITIVE_VIEW;
    $scope.screenState.recommendationDetailsPanel.selectedHostLadder = $scope.chartData;
  };
  $scope.updateShowAdjustFares = function () {
    $scope.chartData.data.showAdjustFares = !$scope.chartData.data.showAdjustFares;
  };
  $scope.updateShowAdjustDates = function () {
    $scope.chartData.data.showAdjustDates = !$scope.chartData.data.showAdjustDates;
  };
};
FaresOptimizerChartsController.$inject = ['$scope', 'HostViewChartDataService', 'CompetitiveViewChartDataService', 'FaresOptimizerConstants'];
module.exports = FaresOptimizerChartsController;